var _rect, _path, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilter = function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#4649B6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.454 10.87h15.092M8.454 15.937h15.092M8.454 21.004h15.092",
    stroke: "#EDEDF9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.956,
    cy: 15.713,
    r: 1.5,
    fill: "#4649B6",
    stroke: "#EDEDF9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.604,
    cy: 10.716,
    r: 1.5,
    fill: "#4649B6",
    stroke: "#EDEDF9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.616,
    cy: 21.243,
    r: 1.5,
    fill: "#4649B6",
    stroke: "#EDEDF9"
  })));
};
export default SvgFilter;